/**
 * Mixin with an email validator method.
 * Returns an array of translated error messages (empty when valid),
 * ready to bind to a Vuetify `error-messages` prop:
 *
 * :error-messages="emailValidationErrors(email)"
 *
 * Pass { required: false } to allow an empty value.
 */
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default {
  methods: {
    emailValidationErrors (value, { required = true } = {}) {
      const email = (value || '').trim()

      if (email === '') {
        return required ? [this.$i18n.t('errors.orm.required')] : []
      }
      if (!EMAIL_REGEX.test(email)) {
        return [this.$i18n.t('errors.orm.format')]
      }
      return []
    }
  }
}